'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { resolveProfitSplit } from '@/lib/profitSplit';

const ProfitSplitContext = createContext<number | null>(null);

// For copy hardcoded in components; null keeps their old text.
export default function ProfitSplitProvider({
  value,
  children,
}: {
  value: number | null | undefined;
  children: ReactNode;
}) {
  return (
    <ProfitSplitContext.Provider value={resolveProfitSplit(value)}>
      {children}
    </ProfitSplitContext.Provider>
  );
}

export function useProfitSplit(): number | null {
  return useContext(ProfitSplitContext);
}
